/**
 * Componente que monta uma tabela com 4 colunas (date, comments, userKey, username).
 * Tem sempre um cabecalho com no formato | date | comments | user key | username |
 *
 * @author: jdias
 */


 Greenmile.UI = Greenmile.UI || {};
 Greenmile.UI.CommentsTableView = Greenmile.UI.CommentsTableView || {};

 Greenmile.UI.CommentsTableView = (function () {

     /**
      * @name CommentsTableView
      * @description Method to create the CommentsTableView
      * @param {Array} informations Array of obejcts containing date, 
      * comments, userKey and username 
     */
     function CommentsTableView (informations) {
         Monet.UI.TableView.apply(this, arguments);

         this.setHeaders([
             Monet.I18n.getResourcesByKey('eventLog.eventLogNotes.time'),
             Monet.I18n.getResourcesByKey('eventLog.eventLogNotes.comment'),
             Monet.I18n.getResourcesByKey('eventLog.eventLogNotes.user.key'),
             Monet.I18n.getResourcesByKey('eventLog.eventLogNotes.username')
         ]);

         this.generateLines = function () {
             if (informations) {
                 for (let i = 0, length = informations.length; i < length; i++) {
                     const information = informations[i];
                     const line = [
                         new Monet.UI.TableViewCell('TEXT', this.formatDateNotifications(information.date)),
                         new Monet.UI.TableViewCell('TEXT', information.comments),
                         new Monet.UI.TableViewCell('TEXT', information.userKey),
                         new Monet.UI.TableViewCell('TEXT', information.username)
                     ];
                     this.addLine(line);
                 }
             }
         };

         this.formatDateNotifications = function (value) {
             return value ? Monet.Format.DateTime.formatToLocale(value) : '--:--:--';
         };

         this.render = function () {
             this.renderHeader();
             this.generateLines();
             this.renderLines();
             return this.baseEl;
         };

     }

     return CommentsTableView;

 })();
